__webpack_require__.p = "https://prod.in.safer.whs.amazon.dev/";